import { useEffect } from "react";
import Header from '../Header/Header';
import ViewUsers from './ViewUsers';
import { useSelector, useDispatch } from 'react-redux';

export default function UserManagement() {
    const practiceDetails = useSelector(state => state.practiceDetails);
    const setupMessage = practiceDetails?.setupMessage;
    const dispatch = useDispatch();

    // Check setup message on component mount
    useEffect(() => {
        console.log('UserManagement: useEffect - checking setup message');
        // Import and call the setup check function
        import('../../hooks/useAuth').then(({ checkPracticeSetup }) => {
            const loginDetails = JSON.parse(localStorage.getItem('loginDetails'));
            if (loginDetails) {
                checkPracticeSetup(dispatch, loginDetails.jwtToken, loginDetails.loggedInUser);
            }
        });
    }, [dispatch]);

    return (
        <div className="min-h-screen bg-[#edeef2]">
            <Header />

            <main
                className={`
                    pt-[30px] lg:pt-[46px]
                    transition-all duration-300
                    md:ml-2
                `}
            >
                <div className="p-4 sm:p-6">
                    {/* Setup Message */}
                    {setupMessage && (
                        <div className="mb-6 bg-blue-50 border border-blue-200 rounded-lg p-4">
                            <div className="flex">
                                <div className="flex-shrink-0">
                                    <svg className="h-5 w-5 text-blue-400" viewBox="0 0 20 20" fill="currentColor">
                                        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                                    </svg>
                                </div>
                                <div className="ml-3 flex-1">
                                    <p className="text-sm text-blue-800">{setupMessage.message}</p>
                                    
                                </div>
                                <div className="ml-auto pl-3">
                                    <div className="-mx-1.5 -my-1.5">
                                        <button
                                            onClick={() => {
                                                dispatch({ type: 'clearMessage' });
                                            }}
                                            className="inline-flex rounded-md p-1.5 text-blue-400 hover:bg-blue-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-blue-50 focus:ring-blue-600"
                                        >
                                            <span className="sr-only">Dismiss</span>
                                            <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                                <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    
                    <ViewUsers />
                </div>
            </main>
        </div>
    );
}